import React from 'react';
import { AtlassianLogo, JiraLogo } from '@atlaskit/logo';
import { JiraBackground } from '@atlassian/product-wireframes';

import type { CobrandingComponents } from '../../shared-cobranding';
import { useNewUserContinueUrl } from '../common/hooks';
import ImageRouter from '../components/ImageRouter';
import * as Styled from '../common/styled';

function BXPSU2453Variant2Background({ children }: { children: React.ReactNode }) {
  useNewUserContinueUrl();

  return (
    <JiraBackground>
      <Styled.GridContainer>
        <Styled.ModalContainer>
          <Styled.LogoContainerVariant2>
            <JiraLogo appearance="brand" size="large" />
          </Styled.LogoContainerVariant2>
          <Styled.ContentContainer>
            <Styled.WhiteBoxContainer>{children}</Styled.WhiteBoxContainer>
            <ImageRouter productImage={'JIRA'} />
          </Styled.ContentContainer>
          <Styled.FooterVariant2>
            <AtlassianLogo appearance="neutral" size="xsmall" />
          </Styled.FooterVariant2>
        </Styled.ModalContainer>
      </Styled.GridContainer>
    </JiraBackground>
  );
}

const BXPSU2453Variant2Cobranding: CobrandingComponents = {
  background: BXPSU2453Variant2Background,
  logo: null,
  whiteboxWidth: '400px',
  hideWhiteboxBorder: true,
};

export default BXPSU2453Variant2Cobranding;
